import { render } from "./normativa.vue?vue&type=template&id=dd472a66&scoped=true"
import script from "./normativa.vue?vue&type=script&lang=js"
export * from "./normativa.vue?vue&type=script&lang=js"

import "./normativa.vue?vue&type=style&index=0&id=dd472a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd472a66"]])

export default __exports__